var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVerticalPoints(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 30,
    viewBox: "0 0 8 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.40009 25.921C7.40009 24.1315 5.94942 22.6808 4.15994 22.6808C2.37046 22.6808 0.9198 24.1315 0.9198 25.921C0.9198 27.7105 2.37046 29.1611 4.15994 29.1611C5.94943 29.1611 7.40009 27.7105 7.40009 25.921Z",
    fill: "#717171"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.40009 14.5802C7.40009 12.7907 5.94942 11.34 4.15994 11.34C2.37046 11.34 0.9198 12.7907 0.9198 14.5802C0.9198 16.3697 2.37046 17.8203 4.15994 17.8203C5.94943 17.8203 7.40009 16.3697 7.40009 14.5802Z",
    fill: "#717171"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.40009 3.24032C7.40009 1.45084 5.94942 0.000181455 4.15994 0.000181533C2.37046 0.000181612 0.9198 1.45084 0.9198 3.24033C0.9198 5.02981 2.37046 6.48047 4.15994 6.48047C5.94943 6.48047 7.40009 5.02981 7.40009 3.24032Z",
    fill: "#717171"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerticalPoints);
export default __webpack_public_path__ + "static/media/vertical_points.de4dff6d09c441a1964032c7490c296d.svg";
export { ForwardRef as ReactComponent };